export const SEARCH_STATES = {
  INITIAL: 'INITIAL',
  FIRST_FETCHING: 'FIRST_FETCHING',
  FETCHING: 'FETCHING',
  FOUND_RESULTS: 'FOUND_RESULTS',
  NOT_FOUND: 'NOT_FOUND',
};

/**
 * Test constants
 */
export const TEST_ID_INITIAL_STATE_COMPONENT =
  'TEST_ID_INITIAL_STATE_COMPONENT';
